import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDisplayValidateDocumentsSlice } from '../../interfaces/DisplayValidateDocuments'

const displayValidateDocumentsSlice = createSlice({
  name: 'displayValidateDocuments',
  initialState: {
    shouldDisplayValidateDocuments: true,
  },
  reducers: {
    setShouldDisplayValidateDocuments: (
      state: IDisplayValidateDocumentsSlice,
      action: PayloadAction<boolean>
    ) => {
      return {
        shouldDisplayValidateDocuments: action.payload,
      }
    },
  },
})

const { actions, reducer } = displayValidateDocumentsSlice
export const shouldDisplayValidateDocumentsActions = actions

export default reducer
